import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { createMealModel } from '../pages/Dashboard/DiningOrders/Model/MealModel';

const ProviderLayout = () => {
      const [meal, setMeal] = useState({ ...createMealModel() });
    return (
        // <main>
        <Outlet  context={{
                    meal,
                    setMeal,
                }} />
        // </main>
    );
};

export default ProviderLayout;
